import {
  AdditionalMeter,
  AzureOfferPlan,
} from '../../../../modules/privateOffer/reducer'
import { useStyles } from './MeteringPlans.styles'
import { useStyles as usePricingStyles } from '../Sections.styles'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'
import clsx from 'clsx'
import { ViewValueWithTruncate } from '@labrav/common'
import { calculateBuyerPrice } from '@labrav/common'
import { getBaseQuantity } from '../../../MicrosoftViewPricing/PlanMeteringDimensions/PlanMeteringDimensions'
import { DisplayValueData } from '../../../PrivateOfferFormV2/AzureOffer/Plan/PlanRow/MeteringDimensions/MeteringDimensions'

interface MeteringPlansProps {
  plan: AzureOfferPlan
  isISV?: boolean
}

export const MeteringPlans = ({ plan, isISV = false }: MeteringPlansProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const customMeters = plan.pricing?.customMeters?.meters || {}
  const meterEntries = Object.entries(customMeters)

  if (meterEntries.length === 0) {
    return null
  }
  const getPriceToISV = (meterValue: AdditionalMeter): number | null => {
    return meterValue?.pricePerPaymentInUsd || null
  }
  const getPriceFromBuyer = (meterValue: AdditionalMeter): number | null => {
    return calculateBuyerPrice({
      wholesalePrice: (meterValue?.pricePerPaymentInUsd as number) || 0,
      percentage: plan?.markupPercentage || 0,
    })
  }
  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Metering Dimensions</div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell className={classes.headerCell}>Name</TableCell>
              <TableCell className={classes.headerCell}>Unit</TableCell>
              <TableCell
                className={clsx(classes.headerCell, classes.textRight)}
              >
                Public price
              </TableCell>
              <TableCell
                className={clsx(classes.headerCell, classes.textRight)}
              >
                Price to ISV
              </TableCell>
              {!isISV && (
                <TableCell
                  className={clsx(classes.headerCell, classes.textRight)}
                >
                  Price from buyer
                </TableCell>
              )}
              <TableCell
                className={clsx(classes.headerCell, classes.textRight)}
              >
                Quantity
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {meterEntries.map(([meterKey, meterValue], index) => {
              const originalMeter =
                plan?.originalPricing?.customMeters?.meters?.[meterKey]
              return (
                <TableRow key={meterKey} className={classes.dataRow}>
                  <TableCell className={classes.dataCell}>
                    <ViewValueWithTruncate
                      value={meterValue.meteringDimensionName || meterKey}
                    />
                  </TableCell>
                  <TableCell className={classes.dataCell}>
                    {meterValue?.unitOfMeasure || 'N/A'}
                  </TableCell>
                  <TableCell
                    className={clsx(classes.dataCell, classes.textRight)}
                  >
                    <DisplayValueData
                      isPrice
                      id="publicPrice"
                      value={originalMeter?.pricePerPaymentInUsd}
                      precision={5}
                    />
                  </TableCell>
                  <TableCell
                    className={clsx(classes.dataCell, classes.textRight)}
                  >
                    <DisplayValueData
                      isPrice
                      id="priceToISV"
                      value={getPriceToISV(meterValue) || 0}
                      precision={5}
                    />
                  </TableCell>
                  {!isISV && (
                    <TableCell
                      className={clsx(classes.dataCell, classes.textRight)}
                    >
                      <DisplayValueData
                        isPrice
                        id="priceFromBuyer"
                        value={getPriceFromBuyer(meterValue) || 0}
                        precision={5}
                      />
                    </TableCell>
                  )}
                  <TableCell
                    className={clsx(classes.dataCell, classes.textRight)}
                  >
                    {getBaseQuantity(meterValue)}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
